import { render, staticRenderFns } from "./yifankuizfb.vue?vue&type=template&id=b5f44036&scoped=true&"
import script from "./yifankuizfb.vue?vue&type=script&lang=js&"
export * from "./yifankuizfb.vue?vue&type=script&lang=js&"
import style0 from "./yifankuizfb.vue?vue&type=style&index=0&id=b5f44036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f44036",
  null
  
)

export default component.exports